import React from 'react';
import { FaApple, FaGooglePlay } from 'react-icons/fa';
//import appManImage from '../../../assets/images/img_mobileappperson.png';
import appManImage from '../../../assets/images/imgTechMobile.png';

//imgTechMobile.png

import './AppDownloadSection.css';

const AppDownloadSection = () => {
  return (
    <section className="bs-app-section">
      <div className="bs-container">
        <div className="bs-app-row">
          
          {/* LEFT COL: Text & Buttons */}
          <div className="bs-app-content-left">
            <h2>
              Download the Build Start<br />
              app <span className="bs-text-highlight">to stay connected</span>
            </h2>
            <p className="bs-app-desc">Get a better view of what you both want.</p>
            
            <div className="bs-app-buttons-row">
              <a
                href="https://apps.apple.com/us/app/buildstart/id6761248999"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <button className="bs-store-btn-black">
                  <FaApple size={28} />
                  <div className="bs-btn-text">
                    <span className="small">Download on the</span>
                    <span className="large">App Store</span>
                  </div>
                </button>
              </a>

              <a
                href="https://play.google.com/store/apps/details?id=au.buildstart.mobile"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <button className="bs-store-btn-black">
                  <FaGooglePlay size={24} />
                  <div className="bs-btn-text">
                    <span className="small">GET IT ON</span>
                    <span className="large">Google Play</span>
                  </div>
                </button>
              </a>
            </div>
          </div>

          {/* RIGHT COL: Image Anchored to Bottom */}
          <div className="bs-app-image-wrapper">
             <img src={appManImage} alt="App User" className="bs-app-man-img" />
          </div>

        </div>
      </div>
    </section>
  );
};

export default AppDownloadSection;
